import React, { useState } from 'react';

const VideoPlayer = (props) => {
  const [showIframe, setShowIframe] = useState(false);
  const youtubeButtonUrl = props.video;

  const handlePlayVideo = () => {
    setShowIframe(true);
  };


  return (
    <div className="video" style={{ transform: 'translate(0px, -190px)', textAlign: 'center'}}>
      {showIframe ? (
        <div className="video__youtube">
          <iframe
            className="video__iframe"
            src={`https://www.youtube.com/embed/${youtubeButtonUrl}?autoplay=1`}
            frameBorder="0"
            allowFullScreen
            height="250"
          ></iframe>
        </div>
      ) : (
        <div className="video__youtube" data-youtube>
          <img
            src="https://marketingtool.online/en/youtube-thumbnail-download/images/placeholder.jpg"
            className="video__placeholder"
            alt="Video Placeholder"
            width="300"
            height="250"
            onClick={handlePlayVideo}
          />
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;